const DetectedPauseCutoffPopup = ({ closePopup }) => {
  return (
    <div className="speakingPopupWrapper">
      <div className="speakingPopupBackdrop" />
      <div className="speakingPopupContainer" style={{ maxWidth: "350px" }}>
        <div className="speakingPopupHeaderContainer">
          <h2>Detected Pause Cutoff</h2>
          <button
            className="speakingPopupCloseButton popupCloseButton"
            onClick={closePopup}
          />
        </div>
        <div className="speakingSettingsPopupContentWrapper">
          <p style={{ margin: 0 }}>
            Setting your detected pause cutoff will set the amount of detected
            pause time required before your recording is ended and sent to the
            server. Adjust the slider to change your cutoff duration.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DetectedPauseCutoffPopup;
